import React, { useState, useEffect } from "react";
import { Activity, AlertCircle, CheckCircle2, TrendingUp, Clock } from "lucide-react";
// import { getAsperoHealth } from "@/services/api/aspero";

/**
 * Real-time system health monitoring widget for Aspero webhook system
 * Displays health status, metrics, and auto-refreshes every 30 seconds
 */
const HealthMonitor = ({ autoRefresh = true, refreshInterval = 30000 }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
      <div className="flex items-center text-gray-600">
        <Activity className="h-5 w-5 mr-2" />
        <span className="text-sm font-medium">Health metrics are currently disabled.</span>
      </div>
    </div>
  );
};

export default HealthMonitor;
